import { Controller } from "stimulus"
import { createPopper } from "@popperjs/core"
import { ModuleFactory } from "@dashboardcode/bsmultiselect";
import {SearchAPI} from "../utils/search_api";

export default class extends Controller {
    static targets = []
    static values = {}

    connect() {
        let environment = {window, createPopper}
        let dashboardCode = ModuleFactory(environment)
        let bsMultiSelect = dashboardCode.BsMultiSelect($("#language_select")[0])
        dashboardCode.BsMultiSelect($("#newspaper_select")[0])
        dashboardCode.BsMultiSelect($("#month_select")[0])
        dashboardCode.BsMultiSelect($("#day_select")[0])
        $("#keyphrases_inputs").find("button.remove_kp").addClass("disabled") // Disable the delete button on loading page
    }

    addKeyPhraseInput(event) {
        $("#keyphrases_inputs").append('<div id="keyphrase_spinner" class="spinner-border m-auto" role="status">\n' +
            '  <span class="visually-hidden">Loading...</span>\n' +
            '</div>')
        $("#keyphrases_inputs").find("button.disabled").removeClass("disabled")
        let maxKpId = 0
        for(const kp of $(".keyphrase_input")) {
            const currentId = parseInt($(kp).attr('id').split('_').pop())
            if (maxKpId < currentId) {
                maxKpId = currentId
            }
        }
        SearchAPI.keyphrase_search_field(maxKpId+1, (data) => {
            $("#keyphrases_inputs div").last().remove()
            $("#keyphrases_inputs").append(data['content'])
        })
        event.preventDefault()
    }

    removeKeyPhraseInput(event) {
        if ($("#keyphrases_inputs").children().length > 1) {
            $(event.target).parent().parent().remove()
            if ($("#keyphrases_inputs").children().length == 1) {
                $("#keyphrases_inputs").find("button.remove_kp").addClass("disabled")
            }
        }
        event.preventDefault()
    }

    generate_keyphrase_input(nextKpId) {
        const new_input = $("" +
            "    <div id=\"kp_" + nextKpId + "\" class=\"keyphrase_input d-inline-flex justify-content-between align-items-center mb-3\">\n" +
            "        <div class=\"input-group\">\n" +
            "            <span class=\"input-group-text\">Search for:</span>\n" +
            "            <input name=\"kp" + nextKpId + "\" type=\"text\" class=\"form-control\" value=\"\">\n" +
            "        </div>\n" +
            "        <div class=\"btn-group\" role=\"group\">\n" +
            "            <input type=\"radio\" class=\"btn-check\" name=\"kp" + nextKpId + "_presence\" value=\"must\" id=\"kp" + nextKpId + "_must\" autocomplete=\"off\" checked>\n" +
            "            <label class=\"btn btn-outline-primary\" for=\"kp" + nextKpId + "_must\">Must</label>\n" +
            "            <input type=\"radio\" class=\"btn-check\" name=\"kp" + nextKpId + "_presence\" value=\"can\"  id=\"kp" + nextKpId + "_can\"autocomplete=\"off\">\n" +
            "            <label class=\"btn btn-outline-primary\" for=\"kp" + nextKpId + "_can\">Can</label>\n" +
            "            <input type=\"radio\" class=\"btn-check\" name=\"kp" + nextKpId + "_presence\" value=\"must_not\"  id=\"kp" + nextKpId + "_must_not\"autocomplete=\"off\">\n" +
            "            <label class=\"btn btn-outline-primary\" for=\"kp" + nextKpId + "_must_not\">Must Not</label>\n" +
            "        </div>\n" +
            "        <div class=\"btn-group\" role=\"group\">\n" +
            "            <input type=\"radio\" class=\"btn-check\" name=\"kp" + nextKpId + "_search_type\" value=\"exact\" id=\"kp" + nextKpId + "_exact\" autocomplete=\"off\" checked>\n" +
            "            <label class=\"btn btn-outline-primary\" for=\"kp" + nextKpId + "_exact\">Exact</label>\n" +
            "            <input type=\"radio\" class=\"btn-check\" name=\"kp" + nextKpId + "_search_type\" value=\"stemmed\" id=\"kp" + nextKpId + "_stemmed\" autocomplete=\"off\">\n" +
            "            <label class=\"btn btn-outline-primary\" for=\"kp" + nextKpId + "_stemmed\">Stemmed</label>\n" +
            "        </div>" +
            "        <div class=\"input-group\">\n" +
            "            <button type=\"button\" class=\"add_kp btn btn-sm btn-info px-2 d-flex align-items-center justify-content-between\"\n" +
            "                    data-action=\"click->advanced-search#addKeyPhraseInput\">\n" +
            "                <i class=\"me-2 fas fa-plus-circle\"></i>Add\n" +
            "            </button>\n" +
            "            <button type=\"button\"\n" +
            "                    class=\"remove_kp btn btn-sm btn-danger px-2 d-flex align-items-center justify-content-between me-2\"\n" +
            "                    data-action=\"click->advanced-search#removeKeyPhraseInput\">\n" +
            "                <i class=\"me-2 fas fa-trash\"></i>Delete\n" +
            "            </button>\n" +
            "        </div>" +
            "    </div>")
        return new_input
    }
}